export default __webpack_public_path__ + "static/media/eye.ccdfed05.jpg";